




import { Component, Vue } from "vue-property-decorator";
import AnagraficaList from "@/packages/albo/anagrafica/AnagraficaList.vue";
import packageInfo from "../../../package.json";

@Component({
  components: {
    AnagraficaList,
  },
})
export default class Albo extends Vue {
  hideall = false;

  constructor() {
    super();
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);

    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    if (params.get("profileid")?.length) {
      this.hideall = true;
    }
  }
}
